import gql from 'graphql-tag'
import { Role } from '@contrast-security-inc/base-types'

export type OrganizationType = 'Freemium' | 'Restricted' | 'Standard'

interface LicenseBreakdown {
  readonly unused: number
  readonly used: number
}

export interface Organization {
  readonly id: string
  readonly type: OrganizationType
  readonly role: Role
  readonly assessLicenseBreakdown: LicenseBreakdown
  readonly protectLicenseBreakdown?: LicenseBreakdown
  readonly restrictedEditRole?: boolean
}

export interface Viewer {
  readonly id: string
  readonly firstName: string
  readonly lastName: string
  readonly currentOrganization: Organization
  readonly protect: boolean
  readonly locale: string
  readonly datePreference: {
    readonly showPeriod: boolean
  }
}

export const organizationFragment = gql`
  fragment Organization on Organization {
    __typename
    id
    type
    role
    assessLicenseBreakdown {
      used
      unused
    }
    protectLicenseBreakdown {
      used
      unused
    }
    restrictedEditRole
  }
`

export const viewerFragment = gql`
  fragment Viewer on User {
    id
    firstName
    lastName
    protect
    currentOrganization {
      ...Organization
    }
    locale
    datePreference {
      showPeriod
    }
  }

  ${organizationFragment}
`

export const viewerQuery = gql`
  query Viewer($organizationID: ID) {
    viewer(organizationID: $organizationID) {
      ...Viewer
    }
  }

  ${viewerFragment}
`
